import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListIndented20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconListIndented20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 4v12a.75.75 0 0 0 1.5 0V4A.75.75 0 0 0 2 4m16.078.75a.75.75 0 0 1-.75.75H5.672a.75.75 0 0 1 0-1.5h11.656a.75.75 0 0 1 .75.75m-2.69 3.5a.75.75 0 0 1-.75.75H5.672a.75.75 0 0 1 0-1.5h8.966a.75.75 0 0 1 .75.75m1.94 4.25a.75.75 0 0 0 0-1.5H5.672a.75.75 0 0 0 0 1.5zm-1.94 2.75a.75.75 0 0 1-.75.75H5.672a.75.75 0 0 1 0-1.5h8.966a.75.75 0 0 1 .75.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListIndented20);
